import React, { useEffect, useState } from 'react';
import { createActionSettingsSchema, getUserRoleFromApi } from '../../ActionForm';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { getFieldInfoByName } from '../collection/Util';
import { getFieldDescriptionTextByName } from '../../ActionFormUtils';
import { iconForField } from '../../../../common/custom/icon-library';
import BrowserStorageOptions from '../BrowserStorageOptions';
import CustomLoader from '../../../common/CustomLoader';

export const AddUserToTenantForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [rolesOptions, setRolesOptions] = useState([]);
  const [userRole, setUserRole] = useState('');
  const [showBSLOption, setShowBSLOption] = useState(false);

  useEffect(() => {
    getUserRoleFromApi(projectId, version).then((res) => {
      let roles = res.data && Array.isArray(res.data) ? res.data : [];
      let rolesOptions = roles.map((role, key) => ({ value: role.name, label: role.name }));
      setRolesOptions(rolesOptions);
    });
    actionData.args.forEach((arg) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === arg.name;
      });
      if (dbParameters) {
        if (arg.name === 'userRole') setUserRole(dbParameters.value);
      }
    });
  }, [actionData]);

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  const validateFormDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateFormDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  const validateResponseDataSessionKey = (value) => {
    console.log(
      '🚀 ~ file: CollectionActionForm.js:117 ~ CollectionActionForm validateResponseDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  const handleRoleChange = (value, setFieldValue) => {
    setUserRole(value);
    setFieldValue('userRole', value);
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        setSubmitting(false);
        resetForm();
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors, isValidating }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Select User Role"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select User Role.'}
                >
                  <CustomSelect
                    name={'userRole'}
                    isMulti={false}
                    onChange={(name, value) => handleRoleChange(value, setFieldValue)}
                    onBlur={setFieldTouched}
                    options={rolesOptions}
                    value={userRole}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
              <div className="form-group" key="userSettings">
                <div className="input-group">
                  <div className="input-group-prepend" title="Add User Settings">
                    <span className="input-group-text">
                      <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                    </span>
                  </div>
                  <div className="form-check">
                    <label className="form-check-label">
                      <Field
                        type="checkbox"
                        name="userSettings"
                        className="form-check-input"
                        title="userSettings"
                      />
                      Add User Settings
                      <span className="form-check-sign">
                        <span className="check"></span>
                      </span>
                    </label>
                    <ErrorMessage name="userSettings">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Alert Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('confirmationMessage')}
                  >
                    <Field
                      name="confirmationMessage"
                      type="text"
                      placeholder="(Optional) A custom confirmation alert message to display on a popup"
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                  <small className="input-group" style={{ paddingLeft: '12%' }}>
                    {getFieldDescriptionTextByName('confirmationMessage')}
                  </small>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Success Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('successMessage')}
                  >
                    <Field
                      name="successMessage"
                      type="text"
                      placeholder="(Optional) Enter custom success message."
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Error Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('errorMessage')}
                  >
                    <Field
                      name="errorMessage"
                      type="text"
                      placeholder="(Optional) Enter custom error message."
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
              <div className="form-group">
                <button
                  onClick={(e) => setShowBSLOption(!showBSLOption)}
                  className="btn btn-icon-only btn-outline-info ml-5 p-1"
                  title="Show Browser Storage Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                </button>
              </div>
              {showBSLOption && (
                <BrowserStorageOptions
                  values={values}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validateFormDataSessionKey={validateFormDataSessionKey}
                  validateResponseDataSessionKey={validateResponseDataSessionKey}
                />
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i> Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className={`btn btn-sm btn-theme-submit`}>
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
